import { render, staticRenderFns } from "./SortCandidatesButton.vue?vue&type=template&id=08a2bad8&"
import script from "./SortCandidatesButton.vue?vue&type=script&lang=js&"
export * from "./SortCandidatesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports